import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | VNDC 2.0',
  defaultTitle: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
  description: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@VNDC',
    site: '@VNDC',
  },
  openGraph: {
    title: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
    description: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
    images: [{ url: 'https://cloudfront.goonus.io/images/vndc2.0.png' }],
    // thumbnail share link
  },
}

export const SEO_EN: DefaultSeoProps = {
  // titleTemplate: '%s | VNDC 2.0',
  defaultTitle: 'VNDC 2.0 | Liquidity-Backed Protocol',
  description: 'VNDC 2.0 | Liquidity-Backed Protocol',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@VNDC',
    site: '@VNDC',
  },
  openGraph: {
    title: 'VNDC 2.0 | Liquidity-Backed Protocol',
    description: 'VNDC 2.0 | Liquidity-Backed Protocol',
    images: [{ url: 'https://cloudfront.goonus.io/images/vndc2.0.png' }],
    // thumbnail share link
  },
}

export const seo = {
  title: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
  defaultTitle: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
  description: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@VNDC',
    site: '@VNDC',
  },
  openGraph: {
    title: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
    description: 'VNDC 2.0 | Giải pháp đảm bảo thanh khoản trên chuỗi',
    images: [{ url: 'https://cloudfront.goonus.io/images/vndc2.0.png' }],
    // thumbnail share link
  },
}

export const seoEN = {
  title: 'VNDC 2.0 | Liquidity-Backed Protocol',
  defaultTitle: 'VNDC 2.0 | Liquidity-Backed Protocol',
  description: 'VNDC 2.0 | Liquidity-Backed Protocol',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@VNDC',
    site: '@VNDC',
  },
  openGraph: {
    title: 'VNDC 2.0 | Liquidity-Backed Protocol',
    description: 'VNDC 2.0 | Liquidity-Backed Protocol',
    images: [{ url: 'https://cloudfront.goonus.io/images/vndc2.0.png' }],
    // thumbnail share link
  },
}
